import React from 'react';

import { Box } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';

interface LoginSectionProps {
  showLogin: boolean;
  onPress?: () => void;
  // When true, render the link in the inverse (light) foreground for use over a
  // dark/transparent header; otherwise use the primary foreground.
  inverse?: boolean;
}

export const LoginSection: React.FC<LoginSectionProps> = ({ showLogin, onPress, inverse }) => {
  if (!showLogin) return null;

  const handlePress: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    onPress?.();
  };

  // Keep this as a button action; href="#" resolves against different article
  // routes on the server and client and causes hydration mismatches.
  return (
    <Box
      onClick={handlePress}
      analyticsName="cosmos-sign-in"
      aria-label="Sign in to your account"
      className={cn(
        'w-max cursor-pointer appearance-none rounded-full border-0 bg-transparent px-4 py-2 font-medium no-underline hover:bg-od-bg-hover-primary [text-rendering:optimizeLegibility]',
        inverse ? 'text-od-content-inverse-primary!' : 'text-od-content-primary!',
      )}
    >
      Sign in
    </Box>
  );
};
